import type { CustomIconProps } from '../CustomIcon';

export const PhoneIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round'>
        <path
          d='M22 17.42v3a1.998 1.998 0 0 1-2.18 2 19.791 19.791 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2.5h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 17.42Z'
          fill={color}
          stroke={color}
        />
        <path
          d='M15.05 5.5A5 5 0 0 1 19 9.45M15.05 1.5A9 9 0 0 1 23 9.44'
          stroke={secondaryColor}
        />
      </g>
    </svg>
  );
};
